import React, { Ref } from "react";
import { ApplicationState } from "../store";
import { actions } from "../store/Insurance";
import { ConnectedProps, connect } from "react-redux";
import InsuranceCoverageSelectBase from "./InsuranceCoverageSelectBase";

export const InsuranceCoverageSelect: React.FC<InsuranceCoverageProps> = (props: InsuranceCoverageProps) => {
  return (
    <InsuranceCoverageSelectBase
      selectedCode={props.coverages?.selectedCode}
      selectedName={props.coverages?.selectedName}
      recommendedTitle={props.coverages?.recommendedTitle}
      Coverages={props.coverages?.Coverages}
      CoverageItems={props.coverages?.CoverageItems}
      SelectedDeductible={props.coverages?.SelectedDeductible}
      IsSingleRecommened={props.coverages?.IsSingleRecommened}
      isCarUnder3YearsAndNotImported={props.coverages?.isCarUnder3YearsAndNotImported}
      ui={props.coverages?.ui}
      addons={props.addons}
      onChange={props.onChange}
      showSecondaryPrice={props.showSecondaryPrice}
      showAvatar={props.avatarEnabled}
      forwardedRef={props.forwardedRef}
      deductibleRef={props.deductibleRef}
    />
  );
};

const connector = connect(
  (state: ApplicationState) => ({
    avatarEnabled: state.insurance?.avatarEnabled,
    coverages: state.insurance?.coverage,
    addons: state.addon,
  }),
  {
    onChange: actions.insuranceCoverageChanged,
  },
);

type InsuranceCoverageProps = ConnectedProps<typeof connector> & {
  showSecondaryPrice?: boolean;
  forwardedRef?: Ref<HTMLDivElement>;
  deductibleRef?: Ref<HTMLDivElement>;
};

export default connector(InsuranceCoverageSelect);
